/* Model */
class TicketTypeModel extends App.Models.BaseModel {
  modelUrl = 'TicketType';
}

App.Models.TicketType = TicketTypeModel;

/* Collection */
class TicketTypeCollection extends App.Collections.BaseCollection {
  url = 'TicketType';
  model = App.Models.TicketType;
}

App.Collections.TicketTypes = TicketTypeCollection;

/* Router */
class TicketTypeRouter extends App.Routers.BaseRouter {
  constructor() {
    const entityName = 'TicketType';
    const model = App.Models.TicketType;
    const collectionClass = App.Collections.TicketTypes;

    super(entityName, model, collectionClass);
  }
}

App.Routers.TicketType = TicketTypeRouter;